var titleGapMapReverse = {
  xl: 55,
  l: 55,
  m: 55,
  s: 40,
  xs: 20
};
var titleSizeMap = {
  xl: 66,
  l: 52,
  m: 36,
  s: 24,
  xs: 22
};
export var getTitleSize = function getTitleSize(size, reverse) {
  if (reverse) {
    return {
      width: "calc(100% - ".concat(titleGapMapReverse[size], ")px"),
      height: titleSizeMap[size]
    };
  }
  return {
    width: "calc(100% - ".concat(size === 'xl' ? 55 : 100, ")px"),
    height: titleSizeMap[size]
  };
};
var subTitleGapMapReverse = {
  xl: 400,
  l: 200,
  m: 200,
  s: 100,
  xs: 60
};
export var getSubTitleSize = function getSubTitleSize(size, reverse, second) {
  if (reverse) {
    return {
      width: "calc(100% - ".concat(subTitleGapMapReverse[size], "px)"),
      height: size === 'xl' || size === 'l' ? 22 : 16
    };
  }
  return {
    width: "calc(100% - ".concat(second ? '260px' : '200px', ")"),
    height: size === 'xl' || size === 'l' ? 22 : 16
  };
};